export default "//cloud.imgsmail.ru/cloud.mail.ru/188971/img/build/aside-promo-modal/default-quota-10.jpg";